import React from 'react'
import './styles.scss'

export const Image = ({
    file,
    source,
    caption,
    onDark = false
}: {
    file?: string
    source?: string
    caption?: string
    onDark?: boolean
}) => {
    return (
        <figure className={'Image' + (onDark ? " dark" : "")}>
            <div className='imageholder'>
                <img src={require('images/' + file)} />
            </div>
            <figcaption>
                {caption && <div className='caption'>{caption}</div>}{' '}
                {source && <div className='source'>Foto:{" "}{source}</div>}
            </figcaption>
        </figure>
    )
}
